<template>
    <div class="roadblock">
        <div class="rb-content animated slideInUp">
            <h1>Reporting Roadblock</h1>
            <p>The APS captures part of the license plate number and makes a note to file a report later. The APS ultimately forgets to follow-up.</p>
            <p><strong>This incident is never entered into the case management system.</strong></p>
        </div>
        <router-link to="/trivia-7">
            <NextButton />
        </router-link>
    </div>
</template>

<script>
import NextButton from '@/components/NextButton.vue'

export default {
  name: 'roadblock',
  components: {
    NextButton
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.roadblock {
    background: url("~@/assets/roadblock-bg.jpg") center center no-repeat;
    background-color:#000;
    background-size: cover;
    height: 100%;
    width: 100%;
}

.rb-content {
    text-align: left;
    background: url("~@/assets/roadblock-modal.png") center center no-repeat;
    background-size: cover;
    width: 392px;
    height: 261px;
    position: absolute;
    top: 60px;
    left: 135px;
}

h1 { 
    color: #fff;
    padding: 30px 0 20px 80px;
    font-size: 28px;
}
p {
    color: #4A4A4A;
    padding: 0 30px;
    font-size: 18px;
}
</style>
